import { weatherStore } from "../store";
import { get } from 'svelte/store';
import { utils } from "./Utils";
const { weatherData, selectedCity, storedDate, carouselInstance, currentIndex, fiveDayData, sliderData, curretDay, mobileCurrentCityObservationData, dayIndex } = weatherStore;
class CityOptions {
    changeCity(city, saveToCookie) {
        let $fiveDayData = get(fiveDayData);
        let $storedDate = get(storedDate);
        let $weatherData = get(weatherData);
        let $dayIndex = get(dayIndex);
        if (saveToCookie) {
            // @ts-ignore
            localStorage.setItem("weatherLocation", city);
        }
        let that = this;
        $weatherData.map(function (element, index) {
            try {
                if (element.city === city) {
                    let sliderHours = utils.setSliderHours(element);
                    sliderData.set(sliderHours);
                    selectedCity.set(element);
                    that.currentObservationData(element.data.forecast24h[$dayIndex]);
                }
            }
            catch (error) {
                console.log('error changeCity', error);
            }
        });
        this.changeHour($storedDate);
    }
    getPageIndex(index, day, moveToHourByIndex) {
        if (day) {
            let move = true;
            let $sliderData = get(sliderData);
            let sliderIndex;
            $sliderData.map(function (el, pageIndex) {
                if (day.date === el.dateSLO && el.index === moveToHourByIndex && move) {
                    sliderIndex = el.sliderIndex;
                    move = false;
                }
            });
            return sliderIndex;
        }
    }
    currentObservationData(element) {
        if (element.timeline[0]) {
            element.maxTemp = element.timeline[0].txsyn;
            element.minTemp = element.timeline[0].tnsyn;
            element.icon = element.timeline[0].clouds_icon_wwsyn_icon,
                element.icon_text = utils.capitalizeFirstLetter(element.timeline[0].clouds_shortText_wwsyn_shortText),
                mobileCurrentCityObservationData.set(element);
        }
    }
    changeTab(index, day) {
        let moveHour = true;
        if (index > 0) {
            curretDay.set(false);
        }
        else {
            curretDay.set(true);
        }
        dayIndex.set(index);
        let $sliderData = get(sliderData);
        //let $storedDate = get(storedDate)
        let $carouselInstance = get(carouselInstance);
        //let $currentIndex = get(currentIndex)
        let $selectedCity = get(selectedCity);
        let that = this;
        $selectedCity.data.forecast24h.map(function (forecastElement, forecastIndex) {
            forecastElement.selected = false;
            if (forecastIndex === index) {
                forecastElement.selected = true;
                that.currentObservationData(forecastElement);
            }
        });
        let page;
        if ($sliderData) {
            let moveToHourByIndex = 0;
            if (index === 0) {
                $sliderData.map(function (element, dataIndex) {
                    element.active = false;
                });
                $sliderData[0].active = true;
                storedDate.set($sliderData[0]);
                page = 0;
            }
            else {
                let stored;
                $sliderData.map(function (element, dataIndex) {
                    element.active = false;
                    const futureTime = new Date(element.valid);
                    const futureTimeHour = futureTime.getUTCHours();
                    //let currentTime = new Date($sliderData[0].valid);
                    let currentHour = 6; //currentTime.getUTCHours(); //UPORABI 7 zjutraj kot referenco
                    if (index === 1) {
                        if (day.date === element.dateSLO && futureTimeHour === currentHour) {
                            moveToHourByIndex = element.index;
                            stored = element;
                            element.active = true;
                            moveHour = false;
                        }
                    }
                    else {
                        if (day.date === element.dateSLO) {
                            if (futureTimeHour === currentHour) {
                                moveToHourByIndex = element.index;
                                stored = element;
                                element.active = true;
                                moveHour = false;
                            }
                            else if (futureTimeHour > currentHour && moveHour) {
                                moveToHourByIndex = element.index;
                                stored = element;
                                element.active = true;
                                moveHour = false;
                            }
                        }
                        //check if the same hour as $sliderData[0].time exists in element.time
                        /*  if (day.date === element.dateSLO && element.time === $sliderData[0].time) {
                         
                          
                            moveToHourByIndex = element.index
                            stored = element
                            element.active = true
                          } else {
                          } */
                    }
                });
                storedDate.set(stored);
                page = this.getPageIndex(index, day, moveToHourByIndex);
            }
        }
        selectedCity.set($selectedCity);
        sliderData.set($sliderData);
        // @ts-ignore
        $carouselInstance.goTo(page);
    }
    changeHour(time) {
        let $selectedCity = get(selectedCity);
        $selectedCity.data.forecast24h.map(function (forecastElement, forecastIndex) {
            try {
                forecastElement.selected = false;
                if (forecastElement.date === time.date) {
                    forecastElement.selected = true;
                }
            }
            catch (error) {
                console.log('error changeHour', error);
            }
        });
        let $sliderData = get(sliderData);
        $sliderData.map(function (element, index) {
            element.active = false;
            if (element.valid === time.valid) {
                element.active = true;
                storedDate.set(time);
            }
        });
        sliderData.set($sliderData);
        selectedCity.set($selectedCity);
    }
}
export const cityOptions = new CityOptions();
